<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.ItProviderDetails"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [isNewModalDesign]="true"
  [hasBackButton]="false"
  [hasUserProfile]="false"
/>

<div
  class="mt-2 font-poppins text-[24px] font-medium leading-[34px] tracking-[-0.7px] text-[#595959] xs:text-[30px] xs:leading-[45px]"
>
  <span>{{ 'site_setup_it_provider_title_part1' | translate }}</span>&nbsp;<span class="text-background">{{ 'site_setup_it_provider_title_part2' | translate }}</span>
</div>

<div class="mt-5 flex flex-col items-start gap-3 xs:flex-row xs:items-center xs:gap-4">
  <div class="flex aspect-square h-18 items-center justify-center rounded-full bg-background-light-blue text-primary-blue">
    <svg-icon key="px-24-shield" [fontSize]="'37px'" />
  </div>
  <p class="font-poppins text-[16px] font-light leading-[24px] text-[#969696]">
    {{ 'site_setup_it_provider_intro' | translate }}
  </p>
</div>

<!-- hs-do-not-collect: HubSpot must not attach the IT person's details to the champion's contact -->
<form class="hs-do-not-collect mt-5 flex flex-col gap-5" [formGroup]="form" (ngSubmit)="next()">
  <section class="flex flex-col gap-3 rounded-3xl bg-background-light-grey p-5">
    <lib-input
      background="white"
      size="large"
      [placeholder]="'site_setup_it_provider_company_name_placeholder' | translate"
      formControlName="itProviderName"
      [hint]="
        hasError(form.controls.itProviderName)
          ? ('site_setup_form_required' | translate)
          : ('site_setup_it_provider_company_name_hint' | translate)
      "
      [state]="hasError(form.controls.itProviderName) ? 'error' : 'normal'"
    />

    <div class="flex w-full flex-col justify-evenly gap-3 xs:flex-row">
      <lib-input
        background="white"
        size="large"
        [label]="'site_setup_it_provider_first_name' | translate"
        formControlName="itPrimaryContactFirstName"
        [hint]="hasError(form.controls.itPrimaryContactFirstName) ? ('site_setup_form_required' | translate) : ''"
        [state]="hasError(form.controls.itPrimaryContactFirstName) ? 'error' : 'normal'"
      />
      <lib-input
        background="white"
        size="large"
        [label]="'site_setup_it_provider_last_name' | translate"
        formControlName="itPrimaryContactLastName"
        [hint]="hasError(form.controls.itPrimaryContactLastName) ? ('site_setup_form_required' | translate) : ''"
        [state]="hasError(form.controls.itPrimaryContactLastName) ? 'error' : 'normal'"
      />
    </div>

    <lib-input
      background="white"
      size="large"
      [label]="'site_setup_it_provider_email' | translate"
      formControlName="itPrimaryContactEmail"
      [hint]="
        hasError(form.controls.itPrimaryContactEmail)
          ? (form.controls.itPrimaryContactEmail.hasError('required')
              ? ('site_setup_form_required' | translate)
              : ('site_setup_form_invalid_email' | translate))
          : ''
      "
      [state]="hasError(form.controls.itPrimaryContactEmail) ? 'error' : 'normal'"
    />

    <lib-input
      background="white"
      size="large"
      [label]="'site_setup_it_provider_phone' | translate"
      formControlName="itPrimaryContactPhoneNumber"
      (valueChange)="onPhoneInput($event)"
      [hint]="
        hasError(form.controls.itPrimaryContactPhoneNumber)
          ? (form.controls.itPrimaryContactPhoneNumber.hasError('required')
              ? ('site_setup_form_required' | translate)
              : ('site_setup_form_invalid_phone' | translate))
          : ''
      "
      [state]="hasError(form.controls.itPrimaryContactPhoneNumber) ? 'error' : 'normal'"
    />

    <div class="mt-2 flex items-center">
      <lib-checkbox [formControl]="form.controls.noItProvider" variant="primary" />
      <p class="ml-2 text-h4 font-light">{{ 'site_setup_it_provider_no_provider' | translate }}</p>
    </div>
  </section>

  <button class="btn-primary mt-4 flex h-[46px] w-full items-center justify-center" type="submit">
    {{ 'site_setup_it_provider_next' | translate }}
  </button>

  <div class="flex flex-col gap-1 text-[#595959]">
    <div class="flex items-center gap-1">
      <svg-icon key="px-24-locked" size="sm" />
      <p class="font-poppins text-[12px] font-normal leading-[24px]">
        {{ 'site_setup_it_provider_security_note_1' | translate }}
      </p>
    </div>
    <div class="flex items-center gap-1">
      <svg-icon key="px-24-locked" size="sm" />
      <p class="font-poppins text-[12px] font-normal leading-[24px]">{{ 'site_setup_it_provider_security_note_2' | translate }}</p>
    </div>
  </div>
</form>
